const tabs = () => {
  const elements = document.querySelectorAll(".fndry-accordion-block");
  elements.forEach((element) => {
    element.addEventListener("click", () => {
      // Use the setTimeout function to wait 201ms
      setTimeout(() => {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          alignToTop: true,
        });
      }, 201);
    });
  });
};

export default tabs;
